module.exports = __webpack_public_path__ + "static/media/fidweb-immotech-germany_optimized.5125f829.png";